import { sendEvent } from './add-activity-stream-event';
import { WordOfTheDayGameEndedEventPayloadV1 } from '@ilteducation/activity-stream-types';

const timestamp = () => new Date().toISOString();

export type GameEventParams = {
  game: string;
};

type GameEndedEventPayload = WordOfTheDayGameEndedEventPayloadV1; // Union type for different game ended events

const useGameEvents = ({ game }: GameEventParams) => {
  let partitionKey: string | null = null;

  const gameStarted = (sessionId: string, userId: string, roles: string[], userOrganisations: string[]) => {
    partitionKey = sessionId;
    sendEvent({
      partitionKey,
      type: 'GameStartedEventV1',
      payload: {
        game,
        sessionId,
        timestamp: timestamp() as any,
        userIdentity: {
          type: 'User',
          id: userId,
          roles,
          organisations: userOrganisations,
        },
      },
    });
  };

  const gameEnded = (endPayload: GameEndedEventPayload) => {
    if (!partitionKey) {
      return;
    }
    sendEvent({
      partitionKey,
      type: 'GameEndedEventV1',
      payload: {
        sessionId: partitionKey,
        timestamp: timestamp() as any,
        ...endPayload,
      },
    });
  };

  return {
    gameStarted,
    gameEnded,
  };
};

export default useGameEvents;
